import * as types from "../constants/ActionConstants";

const initialState = {
    puntosGame: 0,
    time: 60,
    stateGame: false,
    stateHelp: true,
    ayuda: false
};

const Game = (state = initialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case types.GAME_CHANGE_POINTS:
            return { ...state, puntosGame: payload };
        case types.GAME_CHANGE_TIME:
            return { ...state, time: payload };
        case types.GAME_STATE_GAME:
            return { ...state, stateGame: payload };
        case types.GAME_STATE_HELP:
            return { ...state, stateHelp: payload };
        case types.GAME_HELP:
            return { ...state, ayuda: payload };
        default:
            return state;
    }
}

export default Game;